const toggleFolder = (state, action) => {
  const {
    payload: { folderId },
  } = action;
  const { expandedFolders } = state;
  return {
    ...state,
    expandedFolders: {
      ...expandedFolders,
      [folderId]: !expandedFolders[folderId],
    },
  };
};

export default toggleFolder;
